import * as React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Dialog,
  Slide,
  Menu,
  MenuItem,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Prescriptions from "./Prescriptions";
import AdminFeedbackPanel from "./AdminFeedbackPanel";
import Activities from "./Activities";

// ✅ Fix: Properly forwarding props
const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export default function CustomerPageDialog({
  open,
  handleClose,
  customerName,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [activeComponent, setActiveComponent] = React.useState("prescriptions");

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleComponentChange = (component) => {
    setActiveComponent(component);
    handleMenuClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      maxWidth="md"
      fullWidth
    >
      <AppBar
        sx={{
          position: "relative",
          backgroundColor: "#1976d2",
          color: "white",
        }}
      >
        <Toolbar>
          <IconButton
            sx={{ color: "red" }}
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>

          <Typography
            sx={{ flexGrow: 1, fontSize: "18px", fontWeight: "bold" }}
          >
            {customerName || "Customer Details"}
          </Typography>

          <IconButton color="inherit" onClick={handleMenuOpen}>
            <MoreVertIcon />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => handleComponentChange("prescriptions")}>
              Prescriptions
            </MenuItem>
            <MenuItem onClick={() => handleComponentChange("activities")}>
              Activities
            </MenuItem>
            <MenuItem onClick={() => handleComponentChange("feedback")}>
              Feedback
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Box sx={{ maxHeight: "70vh", overflowY: "auto", padding: "16px" }}>
        {activeComponent === "prescriptions" && <Prescriptions />}
        {activeComponent === "activities" && <Activities />}
        {activeComponent === "feedback" && <AdminFeedbackPanel />}
      </Box>
    </Dialog>
  );
}
